export const toolbarHeight = 64;
export const tabsPanelHeight = 64;
export const standardTextFieldHeight = 46;
export const electricCarFuelTypeId = 6;